<div id="panel_surveys" class="collapse show" role="tabpanel" aria-labelledby="heading_surveys">
  <div class="card-body">
    <table class="table table-container">
      <tr class="table__row">
        <th class="table__header">Survey Slug</th>
        <th class="table__header">Complete</th>
        <th class="table__header"></th>
      </tr>
      {{#each surveys}}
        <tr class="table__row">
          <td class="table__cell p-inset-sm">{{slug}}</td>
          <td class="table__cell p-inset-sm">{{#if progress}}true{{else}}false{{/if}}</td>
          <td class="table__cell p-inset-sm">
            {{#if progress}}
              <button class="btn btn-survey btn-primary btn-compact btn-progress bg-color-error-base" data-survey="{{slug}}">Remove</button>
            {{else}}
              <button class="btn btn-survey btn-primary btn-compact btn-progress bg-color-success-base" data-survey="{{slug}}">Add</button>
            {{/if}}
          </td>
        </tr>
      {{/each}}
    </table>
  </div>
</div>
